module.exports = __webpack_public_path__ + "static/media/filter.96505f4b.svg";